// Browser-side executors for the agent's UI tools (agent-service ADR 0020). The agent's
// NavigateTo/HighlightElement calls arrive as tool-call stream events; the effect happens HERE,
// after validating the untrusted args against our own allowlists (the server has the same
// catalogues, but the browser trusts nothing it didn't verify).

// Manually synced with router.tsx and the server catalogue (SparkUiTools.kt).
export const ASSISTANT_ROUTES: ReadonlySet<string> = new Set([
  "/save",
  "/save/basics",
  "/save/documents",
  "/save/contact",
  "/save/pinboard",
  "/grow",
  "/grow/watch",
  "/grow/play",
  "/grow/map",
  "/match",
  "/share",
  "/extended-search",
  "/settings",
]);

// Manually synced with the data-assistant-anchor attributes and SparkUiTools.kt.
export const ASSISTANT_ANCHORS: ReadonlySet<string> = new Set([
  "save.editVisibility",
  "grow.startQuiz",
  "grow.powerMap",
  "match.create",
  "share.create",
]);

export interface UiToolActions {
  navigate: (path: string) => void;
  highlight: (anchor: string) => void;
}

// Execute one agent tool call if it is a UI tool with valid args; unknown tools/args are ignored
// with a debug log (same stance as agent-refresh for unmapped tools).
export function executeUiTool(
  name: string,
  args: Record<string, unknown>,
  actions: UiToolActions,
): void {
  if (name === "NavigateTo") {
    const path = args["path"];
    if (typeof path === "string" && ASSISTANT_ROUTES.has(path)) actions.navigate(path);
    else console.debug("[assistant-ui-tools] ignored NavigateTo with invalid path", path);
  } else if (name === "HighlightElement") {
    const anchor = args["anchor"];
    if (typeof anchor === "string" && ASSISTANT_ANCHORS.has(anchor)) actions.highlight(anchor);
    else console.debug("[assistant-ui-tools] ignored HighlightElement with invalid anchor", anchor);
  }
}
